import React from 'react';
import { useRouter } from 'next/router';
import { Box, Container, Heading, Stack, Text } from '@chakra-ui/react';
import { NextSeo } from 'next-seo';
import { Footer } from '@/components/chakraUIPro/Footer';
import PricingCards from '@/components/Pricing/PricingCards';
import PricingTable from '@/components/Pricing/PricingTable';
import { PlanTier } from '@/data/plans';
import { setPendingPlanTier } from '@/libs/pendingPlan';

const isPricingEnabled =
  process.env.NEXT_PUBLIC_STAGE === 'dev' || process.env.NEXT_PUBLIC_STAGE === 'local';

const PricingPage = () => {
  const router = useRouter();

  if (!isPricingEnabled) {
    return null;
  }

  const handleSelect = (tier: Exclude<PlanTier, 'Enterprise'>) => {
    setPendingPlanTier(tier);
    router.push(`/sign-up?plan=${tier}`);
  };

  const handleContact = () => {
    router.push('/?contact=sales');
  };

  return (
    <>
      <NextSeo
        title='eezi Pricing — Plans for tax-compliant e-invoicing'
        description='Choose your eezi plan. Tax-compliant e-invoicing with legal archiving and AI-powered error handling. Pricing per VAT number.'
        canonical='https://eezi.io/pricing'
      />
      <Box bg='bg-default' _dark={{ bgColor: '#1b222c' }} position='relative' pb='120px'>
        {/*<Navbar py={4} />*/}

        <Container maxW='7xl' py={{ base: '12', md: '20' }}>
          <Stack gap='6' align='center' textAlign='center' mb='10'>
            <Heading size={{ base: '3xl', md: '5xl' }}>Choose your eezi plan</Heading>
            <Text fontSize='xl' color='fg.muted' maxW='2xl'>
              Streamline e-invoicing with tax-compliant processing, legal archiving, and AI-powered error handling.
            </Text>
            <Text fontSize='sm' color='fg.muted'>
              Pricing applies per VAT number / entity · Group structures priced per registered VAT number.
            </Text>
          </Stack>

          <PricingCards onSelect={handleSelect} onContact={handleContact} />

          <Stack gap='4' mt='16'>
            <Heading size='xl' textAlign='center'>
              Compare all features
            </Heading>
            <PricingTable />
          </Stack>
        </Container>

        <Footer />
      </Box>
    </>
  );
};

export default PricingPage;
